import { ref, nextTick } from 'vue'
import Schema from 'async-validator'
import { clone } from '@/common/js/just.js'
import { getPlanFormModel } from '../model/form.js'
import { getPlanFormRules } from '../rules/index.js'
import { PLATFORM, MEDIAS } from '@/common/js/constants.js'

import { getAppNameByMediaId } from '@/api/toutiao.model'
import { AUTO_EXTEND_TRAFFIC_SWITCH, BLUE_FLOW_PACKAGE_SETTING_SWITCH } from '../consts/index.js'
import { useOptimizeGoalRelative } from './useOptimizeGoal.js'

export const usePlanConfigForm = (configForm) => {
  const formRef = ref(null)
  const showPlanInfoModal = ref(false)

  const methods = {
    getFormFileds: () => formRef.value.getForm(),
    setFormFileds: (form) => formRef.value.setForm(form),
    /**
     * @description: 供父组件调用
     * @return {*}
     */
    async validate() {
      const descriptor = getPlanFormRules.call({ planForm: configForm.value.plan, projectForm: configForm.value.project })
      const validator = new Schema(descriptor)
      try {
        await validator.validate(configForm.value.plan)
        return Promise.resolve()
      } catch ({ errors, fields }) {
        console.log('errors output: ', errors)
        console.log('fields output: ', fields)
        return Promise.reject(new Error(1))
      }
    },

    /**
     * @description: 广告表单校验
     */
    formValidator: (done) => {
      formRef.value
        .validate()
        .then(done)
        .catch((e) => {
          const errorElement = document.querySelector('.plan-info .el-form-item__error')
          errorElement?.scrollIntoView({ block: 'center', behavior: 'smooth' })
          console.log('validate error output: ', e)
        })
    },
    async onShowConfigModal() {
      showPlanInfoModal.value = true
      const { plan, project } = configForm.value
      // 通过app_image产品主图判断，如果已存在配置信息，直接覆盖
      const form = plan.app_image ? clone(plan) : getPlanFormModel(project)

      const { isBlueFlowEnable, isDuration } = useOptimizeGoalRelative(project)

      // 蓝海流量、极速智投必须开启智能拓流
      // if (isBlueFlowEnable || isDuration) {
      //   form.auto_extend_traffic = AUTO_EXTEND_TRAFFIC_SWITCH.ON
      // }
      if (project.ch_platform_id === PLATFORM.ANDROID) {
        // 安卓应用获取应用名
        const appName = await getAppNameByMediaId({ mediaId: MEDIAS.TOUTIAO, gameId: project.game.id })
        if (!form.app_name) {
          form.app_name = appName
        }
      }

      nextTick(() => {
        formRef.value.setForm(form)
      })
    }
  }

  return [formRef, showPlanInfoModal, methods]
}
